import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export default function (element, data) {
    const swiperContainer = element.querySelector('.video-swiper');
    const slides = swiperContainer.querySelectorAll('.slide__item');
    let swiper;

    function getShowCount(width) {
        if (width > 1920) return 4;
        if (width > 992) return 3;
        if (width > 768) return 2;
        return 1;
    }

    function navBtnsPos() {
        let slide = swiperContainer.querySelector('.slide__item');
        let slideImage = slide.querySelector('.slide__item_image');
        let nextBtn = element.querySelector(".swiper-button-next");
        let prevBtn = element.querySelector(".swiper-button-prev");

        let imageHeight = slideImage.offsetHeight;

        if (slideImage.offsetHeight > 0) {
            let btnHeight = nextBtn.offsetHeight;
            
            nextBtn.style.top = (imageHeight / 2) - (btnHeight / 2) + 'px';
            prevBtn.style.top = (imageHeight / 2) - (btnHeight / 2) + 'px';
        }
    }

    function initSwiper() {
        const windowWidth = window.innerWidth;
        const showCount = getShowCount(windowWidth);

        if (swiper) swiper.destroy(true, true);

        swiper = new Swiper (swiperContainer, {
            modules: [Navigation],
            slidesPerView: showCount,
            spaceBetween: 30,
            loop: slides.length > showCount,
            navigation: {
                nextEl: element.querySelector(".swiper-button-next"),
                prevEl: element.querySelector(".swiper-button-prev"),
            },
            // breakpoints: {
            //     768: {
            //         slidesPerView: 3,
            //     },
            // }
        });

        navBtnsPos();
    }

    initSwiper();
    window.addEventListener('resize', initSwiper);
}